<template>
  <div class="page">
    <div class="Navigation">
      <el-menu
        :default-active="activePath"
        class="el-menu-demo"
        mode="horizontal"
        router
        collapse-transition
        unique-opened
        open-delay="1"
        @select="handleSelect"
      >
        <!-- 第一级 -->
        <template v-for="navMenu in menuData">
          <!-- 最后一级菜单 -->
          <el-menu-item
            v-if="!navMenu.children"
            :key="navMenu.id"
            :data="navMenu"
            :index="navMenu.path"
          >
            <span slot="title">{{ navMenu.label }}</span>
          </el-menu-item>
          <el-submenu
            v-else
            :key="navMenu.id"
            :data="navMenu"
            :index="navMenu.path"
          >
            <template slot="title">
              <span> {{ navMenu.label }}</span>
            </template>
            <!-- 递归 -->
            <NavMenu :navMenus="navMenu.children"></NavMenu>
          </el-submenu>
        </template>
      </el-menu>
    </div>
  </div>
</template>

<script>
import NavMenu from "./NavMenu.vue";
export default {
  components: {
    NavMenu,
  },
  data() {
    return {
      activePath: "",
      menuData: [],
      parentRoutes: [],
    };
  },
  mounted() {
    this.getUserMenu();
  },
  methods: {
    /* 获取菜单 */
    getUserMenu() {
      this.$http.getRequest("/menu/web/auth/menu", { model: 1 }).then((res) => {
        if (res.data.code === 200) {
          if (this.$store.state.userInfo.userId == 1) {
            this.menuData = res.data.data;
          } else {
            this.menuData = res.data.data[0].children;
          }
          this.menuData.unshift({
            label: "首页",
            path: "/homePage",
          }); // 向数组开头添加元素

          let cur_path = this.$route.path;
          //判断菜单默认选中
          if (cur_path != "/homePage") {
            this.handleSelect(cur_path);
          } else {
            this.handleSelect(this.menuData[0].path);
          }
        }
      });
    },
    handleSelect(val) {
      this.activePath = val;
      const menuTree = this.buildMenuTree(this.menuData, this.activePath);
      this.$parent.breadcrumbS(menuTree);
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    buildMenuTree(menuData, selectedPath) {
      function findSelectedMenu(data, path) {
        for (let item of data) {
          if (item.path === path) {
            return { ...item }; // 创建一个新的对象，包含当前菜单项，并初始化 children 属性为空数组
          }

          if (item.children && item.children.length > 0) {
            const selectedChild = findSelectedMenu(item.children, path);
            if (selectedChild) {
              return { ...item, children: selectedChild }; // 创建一个新的对象，包含当前菜单项和匹配的子菜单项
            }
          }
        }

        return null;
      }

      const selectedMenu = findSelectedMenu(menuData, selectedPath);

      return selectedMenu;
    },
  },
};
</script>
<style lang="less" scoped>
.page {
  width: 100%;
  .Navigation {
    width: 100%;
    height: 45px;
    display: flex;
    justify-content: center;
  }
}
// 颜色
::v-deep .el-menu.el-menu--horizontal {
  background: transparent;
}
// 带有下拉框选中后的样式
::v-deep .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  text-align: center;
  color: red;
  border-bottom: 2px solid red;
  font-size: 18px;
  font-weight: bold;
}
// 单个选中
::v-deep .el-menu > .el-menu-item.is-active {
  text-align: center !important;
  border-bottom: 2px solid red !important;
  color: #000 !important;
  background: transparent !important;
  font-size: 18px !important;
  font-weight: bold !important;
}

// 单个 多个 宽度，文字样式
::v-deep .el-menu--horizontal > .el-menu-item {
  color: #000;
  font-size: 18px;
  font-weight: 400;
}
::v-deep .el-menu--horizontal > .el-submenu .el-submenu__title {
  color: #000;
  font-size: 18px;
  font-weight: 400;
}

// 小三角样式
::v-deep .el-submenu__icon-arrow.el-icon-arrow-down:before {
  //  content: "\\e635"; /* 修改为你想要的图标代码 */
  // font-family: "element-icons"; /* 修改为你想要的字体 */
  // font-size: 16px; /* 修改为你想要的大小 */
  // color: #fff; /* 修改为你想要的颜色 */
  display: none;
}
::v-deep .el-menu--horizontal > .el-submenu .el-submenu__icon-arrow {
  margin-top: 2px;
  display: none;
}
// 鼠标悬停
::v-deep .el-menu--horizontal > .el-menu-item:hover {
  color: red !important;
  background: transparent !important;
  font-size: 18px !important;
  font-weight: bold !important;
}
::v-deep .el-menu--horizontal > .el-submenu .el-submenu__title:hover {
  color: red;
  background: transparent !important;
  font-size: 18px !important;
  font-weight: bold !important;
}
::v-deep .el-menu.el-menu--horizontal {
  border-bottom: solid 1px transparent;
}
</style>